import { formatDataTest } from '@/common/dataTest/DataTest';
import { useNavState } from '@/common/navState/NavStateContext';
import { TreeItem } from '@mui/x-tree-view';

export const SideNavItem = ({ node }) => {
  const { navigateTo } = useNavState();

  const handleClick = (openNewTab) => {
    if (!node.route) {
      return;
    }

    navigateTo(node.route, node.state, openNewTab);
  };

  return (
    <TreeItem
      data-test-id={formatDataTest('sidenav-item', node.displayName)}
      sx={{
        '& .MuiTreeItem-content': {
          px: 2,
          py: 1,
          borderRadius: 5,
          fontSize: '0.95rem',
          color: 'text.primary',
          '&:hover': {
            backgroundColor: 'action.hover',
          },
          // Only apply selected styles to leaf nodes
          ...(node.children?.length === 0 && {
            '&.Mui-selected, &.Mui-focused': {
              backgroundColor: 'primary.light',
              color: 'primary.contrastText',
            },
          }),
        },
        '& .MuiTreeItem-label': {
          paddingLeft: 0.5,
        },
      }}
      itemId={node.id}
      label={node.displayName}
      onClick={(event) => handleClick(event.ctrlKey)}
    >
      {node.children && node.children.map((child) => <SideNavItem key={child.id} node={child} />)}
    </TreeItem>
  );
};
